import { toastr } from 'react-redux-toastr';
import config from '../../config/config';
import { ADDRESS_ACTION_TYPES, ADDRESS_FIELD_NAMES } from './actionTypes';

export const addressActions = {
    requestCountries: () => ({
        type: ADDRESS_ACTION_TYPES.REQUEST_COUNTRIES,
    }),

    receiveCountries: (data) => ({
        type: ADDRESS_ACTION_TYPES.RECEIVE_COUNTRIES,
        data,
    }),

    setAddressFields: (data) => ({
        type: ADDRESS_ACTION_TYPES.SET_ADDRESS_FIELDS,
        data,
    }),
};

const processCountriesApiError = (json, dispatch) => {
    dispatch(addressActions.receiveCountries([]));
    toastr.error('Ошибка сервера: ' + String(json.code) + '. ' + json.message);
};

export const fetchCountries = () => (dispatch) => {
    dispatch(addressActions.requestCountries());

    return fetch(config.API_COUNTRIES_URL)
        .then((response) => response.json())
        .then((json) => {
            if (json.code === 200)
                dispatch(addressActions.receiveCountries(json.data));
            else
                processCountriesApiError(json, dispatch);
        })
        .catch((ex) => {
            dispatch(addressActions.receiveCountries([]));
            toastr.error('Ошибка запроса: ' + String(ex));
        });
};

export const getFormDataForAPI = (fields, languageString = 'ru') => {
    const isJuridic = fields[ADDRESS_FIELD_NAMES.IS_JURIDIC];
    const billingKey = languageString === 'ru' ? 'billing' : 'billing_en';

    const baseData = {
        [languageString === 'ru' ? 'name' : 'name_en']: isJuridic
            ? fields[ADDRESS_FIELD_NAMES.COMPANY]
            : `${fields[ADDRESS_FIELD_NAMES.FIRSTNAME]} ${fields[ADDRESS_FIELD_NAMES.LASTNAME]}`,
        [billingKey]: {
            first_name: fields[ADDRESS_FIELD_NAMES.FIRSTNAME] || '',
            last_name: fields[ADDRESS_FIELD_NAMES.LASTNAME] || '',
            phone_country: fields[ADDRESS_FIELD_NAMES.PHONE_COUNTRY] || '',
            phone: fields[ADDRESS_FIELD_NAMES.PHONE] || '',
            email: fields[ADDRESS_FIELD_NAMES.EMAIL] || '',
            is_juridic: isJuridic,
        },
    };

    if (isJuridic) {
        baseData[billingKey] = {
            ...baseData[billingKey],
            company: fields[ADDRESS_FIELD_NAMES.COMPANY] || '',
            company_chief_name: fields[ADDRESS_FIELD_NAMES.COMPANY_CHIEF_NAME] || '',
            company_contact_name: fields[ADDRESS_FIELD_NAMES.COMPANY_CONTACT_NAME] || '',
            company_ogrn: fields[ADDRESS_FIELD_NAMES.COMPANY_OGRN] || '',
            company_kpp: fields[ADDRESS_FIELD_NAMES.COMPANY_KPP] || '',
            company_inn: fields[ADDRESS_FIELD_NAMES.COMPANY_INN] || '',
            company_job_title: fields[ADDRESS_FIELD_NAMES.COMPANY_JOB_TITLE] || '',
            company_scope: fields[ADDRESS_FIELD_NAMES.COMPANY_SCOPE] || '',
            company_legal_address: fields[ADDRESS_FIELD_NAMES.COMPANY_LEGAL_ADDR] || '',
            company_post_address: fields[ADDRESS_FIELD_NAMES.COMPANY_POST_ADDR] || '',
        };
    }

    return baseData;
};

export const setFieldsFromUserData = (userData) => {
    return {
        [ADDRESS_FIELD_NAMES.FIRSTNAME]: userData?.first_name || '',
        [ADDRESS_FIELD_NAMES.LASTNAME]: userData?.last_name || '',
        [ADDRESS_FIELD_NAMES.PHONE_COUNTRY]: userData?.phone_country || 'RU',
        [ADDRESS_FIELD_NAMES.PHONE]: userData?.phone || '',
        [ADDRESS_FIELD_NAMES.EMAIL]: userData?.email || '',
        [ADDRESS_FIELD_NAMES.IS_JURIDIC]: userData?.is_juridic === "true" || userData?.is_juridic === true,
        [ADDRESS_FIELD_NAMES.COMPANY]: userData?.company || '',
        [ADDRESS_FIELD_NAMES.COMPANY_INN]: userData?.company_inn || '',
        [ADDRESS_FIELD_NAMES.COMPANY_KPP]: userData?.company_kpp || '',
        [ADDRESS_FIELD_NAMES.COMPANY_OGRN]: userData?.company_ogrn || '',
        [ADDRESS_FIELD_NAMES.COMPANY_CHIEF_NAME]: userData?.company_chief_name || '',
        [ADDRESS_FIELD_NAMES.COMPANY_CONTACT_NAME]: userData?.company_contact_name || '',
        [ADDRESS_FIELD_NAMES.COMPANY_JOB_TITLE]: userData?.company_job_title || '',
        [ADDRESS_FIELD_NAMES.COMPANY_SCOPE]: userData?.company_scope || '',
        [ADDRESS_FIELD_NAMES.COMPANY_LEGAL_ADDR]: userData?.company_legal_address || '',
        [ADDRESS_FIELD_NAMES.COMPANY_POST_ADDR]: userData?.company_post_address || '',
    };
};